var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineDocumentCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6 22.75c-4.39 0-6.35-1.96-6.35-6.35v-3.8c0-4.39 1.96-6.35 6.35-6.35h3c.41 0 .75.34.75.75s-.34.75-.75.75h-3c-3.58 0-4.85 1.27-4.85 4.85v3.8c0 3.58 1.27 4.85 4.85 4.85h3.8c3.58 0 4.85-1.27 4.85-4.85v-3c0-.41.34-.75.75-.75s.75.34.75.75v3c0 4.39-1.96 6.35-6.35 6.35H7.6z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 14.15c-2.81 0-3.95-1.14-3.95-3.95V7c0-.3.18-.58.46-.69.28-.12.6-.05.82.16l6.4 6.4c.21.21.28.54.16.82a.74.74 0 0 1-.69.46h-3.2zm-2.45-3.95c0 1.99.46 2.45 2.45 2.45h1.39l-3.84-3.84v1.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6 2.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 5c0-2.07 1.68-3.75 3.75-3.75h2.62c.41 0 .75.34.75.75s-.34.75-.75.75H10C8.76 2.75 7.75 3.76 7.75 5c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM18.44 17c0-.41.34-.75.75-.75 1.14 0 2.06-.93 2.06-2.06V8c0-.41.34-.75.75-.75s.75.34.75.75v6.19c0 1.96-1.6 3.56-3.56 3.56-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8.75c-2.66 0-3.75-1.09-3.75-3.75V2c0-.3.18-.58.46-.69.28-.12.6-.05.82.16l6 6c.21.21.28.54.16.82a.74.74 0 0 1-.69.46h-3zM16.75 5c0 1.83.42 2.25 2.25 2.25h1.19l-3.44-3.44V5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineDocumentCopy);
export default __webpack_public_path__ + "static/media/vuesax-outline-document-copy.608e095c4b1129ccb491c1fd0562605d.svg";
export { ForwardRef as ReactComponent };